import { concat, curry, has, reduce } from "ramda";
import { AccountValueMap, SummedValue } from "../accountValues";
import { Multiplier, ReducedFormula } from "./types";

const collectFormulaSummedValues = (
  formula: ReducedFormula,
  accountValueMap: AccountValueMap
): SummedValue[] => {
  return reduce(
    (total: SummedValue[], [multiplier, id]: [Multiplier, string]) => {
      if (!has(id, accountValueMap)) {
        // FIXME: THERE ARE ERRORS IN FORMULAS
        // https://www.pivotaltracker.com/story/show/159018399
        // There shouldn't be errors in formulas, and this should be an exception.
        // But for the moment, we're stuck with logging them
        // tslint:disable-next-line
        console.warn("Missing formula component: ", id);
        return total;
      }
      const { value, summedValues } = accountValueMap[id];
      return value === undefined ? total : concat(total, summedValues);
    }
  )([], formula);
};

export default curry(collectFormulaSummedValues);



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/formulas/collectFormulaSummedValues.ts